import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import { Toaster, toast } from 'sonner';
// import ThemeSettings from "../core/common/theme-settings";
import { useEffect, useState } from "react";
// import HorizontalSidebar from "../core/common/horizontal-sidebar";
// import TwoColumnSidebar from "../core/common/two-column";
// import StackedSidebar from "../core/common/stacked-sidebar";
import DeleteModal from "../core/modals/deleteModal";
import SessionManager from "./sessionManager/SessionManager";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../src/feature-module/router/all_routes";

const Feature = () => {
  const navigate = useNavigate();
  const routes = all_routes;
  const [showLoader, setShowLoader] = useState(true);
  const headerCollapse = useSelector((state) => state.themeSetting.headerCollapse);
  const mobileSidebar = useSelector(
    (state) => state.sidebarSlice.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state) => state.sidebarSlice.miniSidebar
  );
  const expandMenu = useSelector((state) => state.sidebarSlice.expandMenu);
  const dataWidth = useSelector((state) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);
  const dataLoader = useSelector((state) => state.themeSetting.dataLoader);
  const dataTheme = useSelector((state) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector((state) => state.themeSetting.dataSidebarAll);
  const dataColorAll = useSelector((state) => state.themeSetting.dataColorAll);
  const dataTopBarColorAll = useSelector((state) => state.themeSetting.dataTopBarColorAll);
  const dataTopbarAll = useSelector((state) => state.themeSetting.dataTopbarAll);
  const location = useLocation();

  // const tokenExpire = async () => {             
  //   const token = localStorage.getItem('LoginToken');
  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token);
  //       const iat = decoded?.iat;

  //       if (typeof iat === 'number') {
  //         const now = Math.floor(Date.now() / 1000); // current time in seconds
  //         const expirationTime = iat + (8 * 60 * 60); // iat + 8 hours
  //         const timeRemaining = expirationTime - now;

  //         if (timeRemaining > 0) {
  //           const timeoutId = setTimeout(async () => {
  //             toast.error("Session expired.", { position: "top-right" });
  //             await new Promise(resolve => setTimeout(resolve, 3000));
  //             localStorage.removeItem('LoginToken');
  //             navigate(routes.login);
  //             // window.location.reload(); // optional: force refresh
  //           }, timeRemaining * 1000);

  //           return () => clearTimeout(timeoutId); 
  //         } else {
  //           // If more than 5 minutes already passed
  //           toast.error("Session expired.", { position: "top-right" });
  //           await new Promise(resolve => setTimeout(resolve, 3000));
  //           localStorage.removeItem('LoginToken');
  //           navigate(routes.login);
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Invalid token:', error);
  //       localStorage.removeItem('LoginToken');
  //     }
  //   }
  // }

  // useEffect(() => {

    // tokenExpire();

  // }, []);


  // useEffect(() => {
  //   const currentUnixTimestamp = Math.floor(Date.now() / 1000); // current time in seconds
  //   const fiveMinutesLater = currentUnixTimestamp + 5 * 60;
  //   const token = localStorage.getItem('LoginToken');

  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token);
  //       const expT = decoded?.iat + fiveMinutesLater
  //       if () {
  //         alert(decoded?.iat);
  //         console.log("decoded_iat:", decoded?.iat);
  //       }
  //     } catch (error) {
  //       console.error("Invalid token:", error);
  //     }
  //   }
  // }, [])


  useEffect(() => {
    if (dataTheme === "dark_data_theme") {
      document.documentElement.setAttribute("data-theme", "darks");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);
  useEffect(() => {
    // if (dataLoader === 'enable') {
    //   // Show the loader when navigating to a new route
    //   setShowLoader(true);

    //   // Hide the loader after 2 seconds
    //   const timeoutId = setTimeout(() => {
    //     setShowLoader(false);
    //   }, 2000);

    //   return () => {
    //     clearTimeout(timeoutId); // Clear the timeout when component unmounts
    //   };
    // } else {
    //   setShowLoader(false);
    // }
    window.scrollTo(0, 0);
  }, [location.pathname, dataLoader]);
  // const Preloader = () => {
  //   return (
  //     <div id="global-loader">
  //       <div className="page-loader"></div>
  //     </div>
  //   );
  // };
  return (
    <>

      <Toaster
        position="right-top"
        richColors // enables richer, colorful styles
        theme="light" // or 'dark' or 'system'
      />

      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
       ${dataLayout === "mini" || dataWidth === 'box' ? "mini-sidebar" : ''}
       ${dataLayout === "horizontal" || dataLayout === "horizontal-single" || dataLayout === "horizontal-overlay" || dataLayout === "horizontal-box" ? 'menu-horizontal' : ''}
      ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
      ${dataWidth === 'box' ? 'layout-box-mode' : ''} ${headerCollapse ? "header-collapse" : ""}
     ${(expandMenu && miniSidebar) ||
            (expandMenu && dataLayout === "mini")
            ? "expand-menu"
            : ""
          }
      
      `}
      >
        <>
          {showLoader ?
            <>
              {/* <Preloader /> */}
              <div
                className={`main-wrapper 
        ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <SessionManager />
                <Header />
                <Sidebar />
                {/* <HorizontalSidebar /> */}
                {/* <TwoColumnSidebar/> */}
                {/* <StackedSidebar/> */}
                <Outlet />
                <DeleteModal />
                {/* {!location.pathname.includes("layout") && <ThemeSettings />} */}
              </div>
            </> :
            <>
              <div
                className={`main-wrapper 
        ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <SessionManager />
                <Header />
                <Sidebar />
                {/* <HorizontalSidebar /> */}
                {/* <TwoColumnSidebar/> */}
                {/* <StackedSidebar /> */}
                <Outlet />
                <DeleteModal />
                {/* {!location.pathname.includes("layout") && <ThemeSettings />} */}
              </div>
            </>}

        </>
        {/* <Loader/> */}

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
